import { FC } from 'react';

import { FormikProps } from 'formik';

import { Flex } from 'src/components/Flex';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import getPostalLabel from 'src/lib/postalLabel';
import { isApplicationEditable } from 'src/pages/MerchantApplicationPage/merchantApplicationHelpers.util';
import { ExtendedAddress, Principal } from 'src/types/AddMerchant/merchantInfo';

import AddressSection from '../AddressSection';

interface AddressesFieldArray {
    principal: Principal;
    formik: FormikProps<any>;
    principals: Principal[];
    principalIndex: number;
}
const AddressesFieldArray: FC<AddressesFieldArray> = ({
    principal,
    formik,
    principals,
    principalIndex,
}) => {
    const { merchantApplication } = useAddMerchantContext();
    const isEditingDisabled = isApplicationEditable(merchantApplication);
    const postalLabel = getPostalLabel(merchantApplication?.partner?.countryDetails?.alpha2Code);

    return (
        <Flex flexDirection="column" gap="24px">
            {principal?.addresses?.map((address: ExtendedAddress, index) => {
                return (
                    <AddressSection
                        key={`address-${index}`}
                        heading={
                            address?.type === 'PERSONAL_ADDRESS'
                                ? 'Personal Address'
                                : 'Previous Address'
                        }
                        postalLabel={postalLabel}
                        formik={formik}
                        addressIndex={index}
                        principal={principal}
                        principals={principals}
                        principalIndex={principalIndex}
                        accessor={`addresses[${index}]`}
                        disabled={isEditingDisabled}
                    />
                );
            })}
        </Flex>
    );
};

export default AddressesFieldArray;
